<template>
	<div>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insertBracket('open')" v-on:click.right="insertBracket('close')">( )</v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insertBracket('sqopen')" v-on:click.right="insertBracket('sqclose')">[ ]</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('and')">and</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('or')">or</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('anyof')">any of</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('allof')">all of</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('contains')">contains</v-btn>
		<v-btn small class="mr-1 mt-1" color="primary" text v-on:click="insert('notcontains')">not contain</v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insert('!')"><v-icon>mdi-exclamation</v-icon></v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insert('=')"><v-icon>mdi-equal</v-icon></v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insert('!=')"><v-icon>mdi-not-equal</v-icon></v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1"  color="primary" v-on:click="insertLessThan(false)" v-on:click.right="insertLessThan(true)"><v-icon>mdi-greater-than-or-equal</v-icon></v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insertGreaterThan(false)" v-on:click.right="insertGreaterThan(true)"><v-icon>mdi-greater-than-or-equal </v-icon></v-btn>
		<v-btn icon class="ml-1 mr-1 mt-1" color="primary" v-on:click="insert(',')"><v-icon>mdi-comma </v-icon></v-btn>
	</div>


</template>


<script>
	export default {
		name: "InsertOperator", 
		props: {
		},
		methods: {
			insert(content){
				this.$emit("insert", {content: content})
			},
			insertBracket( direction ){
				event.preventDefault();
				let bracket = "";
				if( direction == "open" ){
					bracket = {content: "("}
				}
				if( direction == "close" ){
					bracket = {content: ")"}
				}
				if( direction == "sqopen" ){
					bracket = {content: "["}
				}
				if( direction == "sqclose" ){
					bracket = {content: "]"}
				}
				this.$emit("insert", bracket )
			},
			insertGreaterThan(orEqualTo){
				event.preventDefault();
				let logic = { content: ">" }
				if( orEqualTo ){ logic.content += "="}
				this.$emit("insert", logic )
			},
			insertLessThan(orEqualTo){
				event.preventDefault();
				let logic = { content: ">" }
				if( orEqualTo ){ logic.content += "="}
				this.$emit("insert", logic )
			} 
		}
	}
</script>